import * as yup from 'yup';

import { USER_TYPE } from 'constants/index';
import { Model as ClientModel } from 'models/user/interface';

import { EndpointError, endpoint } from '../endpoint';
import { ValidationShape, ERROR as VALIDATION_ERROR } from '../validation';

export type SignInParams = Pick<ClientModel, 'type'> & {
  uid: string;
  name: string;
  roomId: string;
};
export type SignInResult = ClientModel & { token: string };
export type SignInError = EndpointError;

export const signInParamsSchema = yup.object().shape({
  type: yup
    .string()
    .oneOf(Object.values(USER_TYPE), VALIDATION_ERROR.INVALID_VALUE)
    .required(VALIDATION_ERROR.REQUIRED),
  uid: yup
    .string()
    .matches(
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
      VALIDATION_ERROR.INVALID_FORMAT,
    ),
  roomId: yup.string().required(VALIDATION_ERROR.REQUIRED),
  name: yup
    .string()
    .matches(/^[A-Za-z\u0590-\u05FF]+(?: [A-Za-z\u0590-\u05FF]+)?$/, VALIDATION_ERROR.INVALID_FORMAT)
    .max(24, VALIDATION_ERROR.INVALID_FORMAT)
    .required(VALIDATION_ERROR.REQUIRED),
} as ValidationShape<SignInParams>);

export const signIn = endpoint<SignInParams, SignInResult, SignInError>({
  method: 'POST',
  url: () => `/auth/client`,
});
